import { pickSection } from '@/components/clinical-shell/section-param';

export const WORKSPACE_HOME = 'overview';

export const WORKSPACE_GROUPS = ['overview', 'stay', 'money', 'insurance', 'documents', 'discharge'] as const;
export type WorkspaceGroupId = (typeof WORKSPACE_GROUPS)[number];

export const WORKSPACE_SECTIONS = [
  { id: 'overview', group: 'overview' },
  { id: 'bed', group: 'stay' },
  { id: 'care-team', group: 'stay' },
  { id: 'bill', group: 'money' },
  { id: 'daily-charges', group: 'money' },
  { id: 'advances', group: 'money' },
  { id: 'packages', group: 'money' },
  { id: 'dues', group: 'money' },
  { id: 'preauth', group: 'insurance' },
  { id: 'documents', group: 'documents' },
  { id: 'discharge', group: 'discharge' },
] as const;
export type WorkspaceSectionId = (typeof WORKSPACE_SECTIONS)[number]['id'];

export interface WorkspaceAccess {
  advances: boolean;
  dailyCharges: boolean;
  packages: boolean;
  dues: boolean;
  insurance: boolean;
}

export function workspaceSectionIds(access: WorkspaceAccess): WorkspaceSectionId[] {
  const hidden = new Set<WorkspaceSectionId>([
    ...(access.advances ? [] : (['advances'] as const)),
    ...(access.dailyCharges ? [] : (['daily-charges'] as const)),
    ...(access.packages ? [] : (['packages'] as const)),
    ...(access.dues ? [] : (['dues'] as const)),
    ...(access.insurance ? [] : (['preauth'] as const)),
  ]);
  return WORKSPACE_SECTIONS.map((section) => section.id).filter((id) => !hidden.has(id));
}

export function groupOfSection(id: WorkspaceSectionId): WorkspaceGroupId {
  return WORKSPACE_SECTIONS.find((section) => section.id === id)?.group ?? 'overview';
}

const LEGACY_EMR_TABS: Readonly<Record<string, string>> = {
  emar: 'emar',
  notes: 'progress-notes',
  vitals: 'vitals',
  investigations: 'investigations',
};

const LEGACY_WORKSPACE_TABS: Readonly<Record<string, WorkspaceSectionId>> = {
  insurance: 'preauth',
  care_team: 'care-team',
  details: 'overview',
};

export type WorkspaceTarget = { kind: 'section'; section: WorkspaceSectionId } | { kind: 'emr'; section: string };

export function workspaceTarget(params: URLSearchParams, available: readonly WorkspaceSectionId[]): WorkspaceTarget {
  const tab = params.get('tab');
  if (!params.get('section') && tab && LEGACY_EMR_TABS[tab]) return { kind: 'emr', section: LEGACY_EMR_TABS[tab] };
  const wanted = params.get('section') ?? (tab ? (LEGACY_WORKSPACE_TABS[tab] ?? tab) : null);
  return { kind: 'section', section: pickSection(wanted, available, WORKSPACE_HOME) as WorkspaceSectionId };
}
